/* Gift Bar - Handles automatic gift product addition when cart reaches threshold */

(function() {
  // Prevent duplicate initialization
  if (window.GiftBarInitialized) return;
  window.GiftBarInitialized = true;

  class GiftBar {
    constructor() {
      this.isProcessing = false;
      this.pendingCheck = false;
      this.storageKey = "giftBar_hasGift";
      this.settingsKey = "giftBar_settings";
      this.init();
      this.bindEvents();
    }

  init() {
    this.giftBar = document.querySelector("[data-gift-threshold]");
    if (this.giftBar) {
      this.threshold = parseInt(this.giftBar.dataset.giftThreshold, 10);
      this.variantId = this.giftBar.dataset.giftVariantId;
      this.productHandle = this.giftBar.dataset.giftProductHandle;
      if (this.variantId && this.productHandle && this.threshold) {
        this.saveSettings();
      }
    } else {
      this.loadSettings();
    }
  }

  saveSettings() {
    try {
      localStorage.setItem(this.settingsKey, JSON.stringify({
        threshold: this.threshold,
        variantId: this.variantId,
        productHandle: this.productHandle
      }));
    } catch (e) {}
  }

  loadSettings() {
    try {
      var saved = localStorage.getItem(this.settingsKey);
      if (saved) {
        var settings = JSON.parse(saved);
        this.threshold = settings.threshold;
        this.variantId = settings.variantId;
        this.productHandle = settings.productHandle;
      }
    } catch (e) {}
  }

  bindEvents() {
    var self = this;
    
    // Check after cart drawer content merges (bubbles up from cart-drawer element)
    document.addEventListener("on:cart:after-merge", function() {
      console.log("GiftBar: on:cart:after-merge fired");
      self.init(); // Re-init to get fresh settings
      self.scheduleCheck();
    });
    
    // Check when cart drawer opens
    document.addEventListener("on:cart-drawer:after-open", function() {
      console.log("GiftBar: on:cart-drawer:after-open fired");
      self.init();
      self.scheduleCheck();
    });
    
    // Also listen directly on cart-drawer element if it exists
    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.addEventListener("on:cart:after-merge", function() {
        console.log("GiftBar: cart-drawer on:cart:after-merge fired");
        self.init();
        self.scheduleCheck();
      });
    }
  }

  scheduleCheck() {
    if (this.pendingCheck) return;
    this.pendingCheck = true;
    var self = this;
    setTimeout(function() {
      self.pendingCheck = false;
      self.checkCart();
    }, 300);
  }

  getGiftState() {
    try {
      return localStorage.getItem(this.storageKey) === "true";
    } catch (e) {
      return false;
    }
  }

  setGiftState(hasGift) {
    try {
      if (hasGift) {
        localStorage.setItem(this.storageKey, "true");
      } else {
        localStorage.removeItem(this.storageKey);
      }
    } catch (e) {}
  }

  async checkCart() {
    console.log("GiftBar: checkCart called, isProcessing:", this.isProcessing);
    if (this.isProcessing) return;
    
    this.giftBar = document.querySelector("[data-gift-threshold]");
    if (this.giftBar) {
      this.threshold = parseInt(this.giftBar.dataset.giftThreshold, 10);
      this.variantId = this.giftBar.dataset.giftVariantId;
      this.productHandle = this.giftBar.dataset.giftProductHandle;
      this.saveSettings();
      console.log("GiftBar: Got settings from DOM", { threshold: this.threshold, variantId: this.variantId });
    } else {
      this.loadSettings();
      console.log("GiftBar: Loaded settings from localStorage", { threshold: this.threshold, variantId: this.variantId });
    }
    
    if (!this.variantId || !this.productHandle || !this.threshold) {
      console.log("GiftBar: Missing settings, skipping");
      return;
    }

    this.isProcessing = true;

    try {
      var cartResponse = await fetch(theme.routes.cart + ".js");
      var cart = await cartResponse.json();
      
      var self = this;
      var giftItems = cart.items.filter(function(item) {
        return String(item.variant_id) === String(self.variantId) || item.handle === self.productHandle;
      });
      
      var cartTotalWithoutGift = cart.total_price;
      giftItems.forEach(function(item) {
        cartTotalWithoutGift -= item.final_line_price;
      });
      
      var shouldHaveGift = cartTotalWithoutGift >= this.threshold;
      var hasGift = giftItems.length > 0;
      
      console.log("GiftBar:", { cartTotalWithoutGift: cartTotalWithoutGift, threshold: this.threshold, shouldHaveGift: shouldHaveGift, hasGift: hasGift });
      
      if (shouldHaveGift && !hasGift) {
        await this.addGiftToCart();
      } else if (!shouldHaveGift && hasGift) {
        for (var i = 0; i < giftItems.length; i++) {
          await this.removeGiftFromCart(giftItems[i].key);
        }
      } else if (giftItems.length > 1) {
        for (var j = 1; j < giftItems.length; j++) {
          await this.removeGiftFromCart(giftItems[j].key);
        }
      } else if (shouldHaveGift && hasGift && giftItems[0].quantity > 1) {
        await this.capGiftQuantity(giftItems[0].key);
      } else {
        this.setGiftState(hasGift);
        this.isProcessing = false;
      }
    } catch (error) {
      console.error("GiftBar error:", error);
      this.isProcessing = false;
    }
  }

  async addGiftToCart() {
    try {
      var response = await fetch(theme.routes.cartAdd, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [{
            id: this.variantId,
            quantity: 1,
            properties: { "_gift": "true" }
          }]
        })
      });
      
      if (response.ok) {
        this.setGiftState(true);
        // Trigger cart refresh
        this.refreshCart();
      }
      this.isProcessing = false;
    } catch (error) {
      console.error("GiftBar add error:", error);
      this.isProcessing = false;
    }
  }

  async capGiftQuantity(itemKey) {
    try {
      var updates = {};
      updates[itemKey] = 1;
      var response = await fetch(theme.routes.cartUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      });
      if (response.ok) {
        this.refreshCart();
      }
      this.isProcessing = false;
    } catch (error) {
      console.error("GiftBar cap error:", error);
      this.isProcessing = false;
    }
  }

  async removeGiftFromCart(itemKey) {
    try {
      var updates = {};
      updates[itemKey] = 0;
      var response = await fetch(theme.routes.cartUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      });
      
      if (response.ok) {
        this.setGiftState(false);
        // Trigger cart refresh
        this.refreshCart();
      }
      this.isProcessing = false;
    } catch (error) {
      console.error("GiftBar remove error:", error);
      this.isProcessing = false;
    }
  }

  refreshCart() {
    // Dispatch event to trigger theme's cart refresh mechanism
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    
    // Also try to directly refresh cart-form if it exists
    var cartForm = document.querySelector('cart-form');
    if (cartForm && typeof cartForm.refresh === 'function') {
      cartForm.refresh();
    }
  }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      window.giftBarInstance = new GiftBar();
    });
  } else {
    window.giftBarInstance = new GiftBar();
  }
})();
